
import React from 'react';


import MainPageComp from './MainPageComp';
import { BrowserRouter, Route, Routes } from "react-router-dom";


import TagPageComp from './TagPageComp';
import ContentCategory from './ContentCategory';
import Topic from './Topic';
import About from './About';
import Privacy from './Privacy';
import Donotsell from './Donotsell';
import NotFound from '../Component/NotFound';
import Contact from './Contact';
import {SearchList} from './SearchList';
import Sitemap from './Sitemap';
import Eventpage from './Event';
import EventDetail from './EventDetail';
import ContentDeleted from "../Component/ContentDeleted";
import Unsubscribe from './Unsubscribe';
const MainRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<MainPageComp />}></Route>
        <Route path="/tag/:subcat" element={<TagPageComp />} />
        <Route path="/:cat_slug/:post_name" element={<Topic />} />

        <Route path="/events" element={<Eventpage />} />
        <Route path="/events/:event_slug" element={<EventDetail />} />
        <Route path="/topic/:cat_slug" element={<ContentCategory />}></Route>
        <Route
          path="/topic/:cat_slug/:subcat"
          element={<ContentCategory />}
        ></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/privacy-policy" element={<Privacy />}></Route>
        <Route path="/opt-out-form" element={<Donotsell />}></Route>
        <Route path="/contact-us" element={<Contact />}></Route>
        <Route exact path="/search/:cat/:searchVal" element={<SearchList />} />
        <Route path="/sitemap" element={<Sitemap />}></Route>

        <Route path="/unsubscribe" element={<Unsubscribe />}></Route> 
        <Route path="*" element={<NotFound />}></Route>
        <Route path="/410" element={<ContentDeleted />}></Route>
      </Routes>
    </>
  );
};

export default React.memo(MainRoutes);